import styled, { css } from 'styled-components';
import { whiteTheme } from 'styles/themes/whiteTheme';
import { Link } from 'ui/Link';

export const RelatedCompaniesAndBrandsItemWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  text-decoration: none;
  :hover {
    text-decoration: none;
    color: #000;
  }
`;
export const RelatedCompaniesAndBrandsOtherMaterials = styled(Link)`
  font-family: lato, sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: #b2b2b2;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  :hover {
    text-decoration: underline;
    color: #b2b2b2;
  }
  text-align: center;
  ${({ theme }) => css`
    ${theme.media.mobileM} {
      font-size: 13px;
      line-height: 16px;
    }
  `};
`;

export const RelatedCompaniesAndBrandsItemImg = styled.img`
  max-width: 100px;
  width: 100%;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 50%;

  ${whiteTheme.media.mobileM} {
    max-width: 213px;
    height: 212px;
  }
`;
export const RelatedCompaniesAndBrandsItemTitle = styled.p`
  margin: 0;
  font-family: cormorant-garamond, serif;
  font-style: normal;
  font-size: 22px;
  font-weight: 400;
  color: #000000;
  line-height: 26px;
  text-align: center;
  margin-bottom: 10px;
  &.translation {
    font-weight: bold;
    display: inline;
  }
`;
export const RelatedCompaniesAndBrandsItemLink = styled(Link)`
  margin: 0;
  font-family: cormorant-garamond, serif;
  font-style: normal;
  font-size: 22px;
  font-weight: 400;
  color: #000000;
  line-height: 26px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;
  display: inline;
  :hover {
    text-decoration: underline;
    color: #000;
  }
`;
export const RelatedCompaniesAndBrandsDescription = styled.div`
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
  color: #000000;
  display: block;
  margin-bottom: 15px;
  text-align: center;
  ${whiteTheme.media.mobileM} {
    font-size: 15px;
    line-height: 22px;
  }
`;
